import React from "react";

import burgerImg from "../../src/assets/foods/burger.avif";
import momoImg from "../../src/assets/foods/momo.avif";
import pizzaImg from "../../src/assets/foods/pizza.avif";
import tomatoImg from "../../src/assets/foods/tomato.avif";
import leafImg from "../../src/assets/foods/leaf.avif";
import lineImg from "../../src/assets/foods/line.avif";

import restaurantIcon from "../../src/assets/icons/restaurant.webp";
import locationIcon from "../../src/assets/icons/location.avif";
import bagIcon from "../../src/assets/icons/bag.avif";

export default function BetterFoodSection() {
    return (
        <section className="!xl:max-w-[100%] h-screen relative overflow-hidden bg-[#f6f6f6] py-24">
            {/* Background Curved Line */}
            <img
                src={lineImg}
                alt="line"
                className="absolute inset-0 h-full w-full object-contain w-[120%] opacity-70 scale-x-[-1]"
            />

            {/* Floating Food Images */}
            <img
                src={burgerImg}
                alt="burger"
                className="absolute left-[18%] top-[34%] w-[170px] md:w-[220px] animate-float"
            />

            <img
                src={momoImg}
                alt="momo"
                className="absolute right-[18%] top-[8%] w-[140px] md:w-[190px] animate-floatSlow"
            />

            <img
                src={pizzaImg}
                alt="pizza"
                className="absolute right-[12%] top-[48%] w-[150px] md:w-[220px] rotate-[-10deg] animate-float"
            />

            {/* Small Floating Elements */}
            <img
                src={tomatoImg}
                alt="tomato"
                className="absolute left-[10%] top-[72%] w-8"
            />

            <img
                src={tomatoImg}
                alt="tomato"
                className="absolute right-[10%] top-[28%] w-8"
            />

            <img
                src={leafImg}
                alt="leaf"
                className="absolute left-[30%] top-[8%] w-8"
            />

            {/* Content */}
            <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
                <h2 className="max-w-[700px] text-5xl font-extrabold leading-tight text-[#ef4f5f] md:text-7xl">
                    Better food for
                    <br />
                    more people
                </h2>

                <p className="mt-8 max-w-[700px] text-xl leading-relaxed text-[#5c6485]">
                    For over a decade, we’ve enabled our customers to discover new
                    tastes, delivered right to their doorstep
                </p>

                {/* Stats Card */}
                <div className="mt-48 flex w-[95vw] max-w-[1200px] flex-col overflow-hidden rounded-[30px] border border-[#ececec] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.05)] md:flex-row">          {/* Item 1 */}
                    <div className="flex flex-1 items-center justify-center gap-5 p-8">
                        <div>
                            <h3 className="text-4xl font-extrabold text-[#3b466b]">
                                3,00,000+
                            </h3>
                            <p className="mt-1 text-xl text-[#5c6485]">restaurants</p>
                        </div>

                        <img
                            src={restaurantIcon}
                            alt="restaurant"
                            className="w-16"
                        />
                    </div>

                    {/* Divider */}
                    <div className="hidden w-px bg-[#ececec] md:block" />

                    {/* Item 2 */}
                    <div className="flex flex-1 items-center justify-center gap-5 p-8">
                        <div>
                            <h3 className="text-4xl font-extrabold text-[#3b466b]">
                                800+
                            </h3>
                            <p className="mt-1 text-xl text-[#5c6485]">cities</p>
                        </div>

                        <img src={locationIcon} alt="location" className="w-16" />
                    </div>

                    {/* Divider */}
                    <div className="hidden w-px bg-[#ececec] md:block" />

                    {/* Item 3 */}
                    <div className="flex flex-1 items-center justify-center gap-5 p-8">
                        <div>
                            <h3 className="text-4xl font-extrabold text-[#3b466b]">
                                3 billion+
                            </h3>
                            <p className="mt-1 text-xl text-[#5c6485]">
                                orders delivered
                            </p>
                        </div>

                        <img src={bagIcon} alt="bag" className="w-16" />
                    </div>
                </div>
            </div>

            {/* Custom Animation */}
            <style jsx>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-12px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        .animate-float {
          animation: float 4s ease-in-out infinite;
        }

        .animate-floatSlow {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
        </section>
    );
}